export const adbErrorText = (error: unknown): string =>
  (error as Error)?.message || String(error ?? "");
